<template>
  <div class="bikes-list-el" v-if="bike">
    <div
      :class="['tile', { 'not-active': bike.StockQuantity <= 0 }]"
      @click="handleMoveToExternalOffer"
    >
      <div class="photo">
        <image-item v-if="bike.Photo" :source="bike.Photo" />
      </div>
      <div class="content">
        <span class="info">{{ bike.CategoryCollection }}</span>
        <h5 class="name">{{ bike.Name.toUpperCase() }}</h5>
        <span class="price">{{
          handlePriceFormat(bike.Price, bike.PromoPrice)
        }}</span>
        <span class="availability" v-if="bike.StockQuantity > 0"
          >Twój rozmiar {{ bike.Size }} jest dostępny!</span
        >
        <span class="availability" v-else
          >Twój rozmiar {{ bike.Size }} jest niedostępny!</span
        >
      </div>
      <div class="btn-primary small">
        {{ $t("buttons.check") }}
      </div>
    </div>
  </div>
</template>
<script>
// axios
import api from "@/axios.config.js";

// components
import ImageItem from "../App/ImageItem.vue";

export default {
  name: "BikeTile",
  props: {
    bikeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      bike: null,
    };
  },
  methods: {
    handleMoveToExternalOffer() {
      window.open(this.bike.Url, "_blank").focus();
    },
    handlePriceFormat: function (price, promoPrice) {
      let value;
      value = promoPrice ? promoPrice : price;
      var parts = value.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      parts.join(".");
      return parts + " zł";
    },
  },
  mounted() {
    api
      .get("/products/getProduct", { params: { id: this.bikeId } })
      .then((res) => {
        this.bike = res.data;
      });
  },
  components: {
    ImageItem,
  },
};
</script>
<style scoped>
button {
  margin-top: 8px;
  border: 1px solid black;
  border-radius: 5px;
  background: transparent;
}
</style>
